import axios from "axios";

export const confirmModule = {
  namespaced: true,
  state: {
    visible: false,
    resolve: null,
    reject: null,
    type: "danger",
    description: "",
    acceptMessage: "Ja",
    acceptMessageDefault: "Ja",
    rejectMessage: "Nej",
    rejectMessageDefault: "Nej"
  },
  actions: {
    showConfirmDialog({ commit }, settings) {
        const promise = new Promise((resolve, reject) => {
          commit('SET_RESOLVE', resolve);
          commit('SET_REJECT', () => commit('SET_VISIBLE', false));
        });

        commit('SET_SETTINGS', settings);
        commit('SET_VISIBLE', true);

        return promise
          .then(() => commit('SET_VISIBLE', false));
    },
  },
  mutations: {
    'SET_SETTINGS'(state, payload) {
      state.type = payload.type || "danger";
      state.description = payload.description || "";
      state.acceptMessage = payload.acceptMessage || state.acceptMessageDefault;
      state.rejectMessage = payload.rejectMessage || state.rejectMessageDefault;
    },
    'SET_VISIBLE'(state, payload) {
      state.visible = !!payload;
      if(!state.visible) {
        state.resolve = null;
        state.reject = null;
      }
    },
    'SET_RESOLVE'(state, payload) {
      state.resolve = payload;
    },
    'SET_REJECT'(state, payload) {
      state.reject = payload;
    }
  },
};
